import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import { Popup, Heading, Button, Link } from 'components';
import * as dvr from 'utils/dvr';
import { closePopup } from '../../actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const DVRNoAnswerPopup = ({ activePopup, actions }) => {
  const dataLayerPush = (action) => {
    window.dataLayer.push({
      event: 'GA_event',
      eventCategory: 'nav|digital-IVR',
      eventAction: action,
      eventLabel: window.location.pathname,
    });
  };

  return (
    <Popup
      opened={activePopup === 'DVR:noAnswer'}
      onClose={actions.closePopup}
    >
      <Heading level={1}>
        Не нашли ответ?
      </Heading>
      <div className={cx('controls')}>
        <Button
          className={['big', cx('button')]}
          onClick={() => {
            dataLayerPush('Вернуться в голосовое меню');
            dvr.returnToVoice();
          }}
        >
          Вернуться в голосовое меню
        </Button>
        <Button
          className={['big', 'default', cx('button')]}
          onClick={() => {
            dataLayerPush('Переключить на оператора');
            dvr.returnToOperator();
          }}
        >
          Переключить на оператора
        </Button>
        <Link
          className={cx('button')}
          onClick={() => {
            dataLayerPush('Выход');
            dvr.exit();
          }}
        >
          Выход
        </Link>
      </div>
    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    activePopup: state.application.popup,
    period: state.detalization.period,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      closePopup,
    }, dispatch),
  };
}

DVRNoAnswerPopup.propTypes = {
  actions: PropTypes.object,
  activePopup: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(DVRNoAnswerPopup);
